import { GENDERS } from '../data';
import { useSurvey } from '../SurveyContext';

export function IdentityStep() {
  const surveyFlow = useSurvey();
  const { answers } = surveyFlow;
  return (
    <>
      <div className="intake-idfields">
        <label className="intake-idf">
          <span>First name</span>
          <input
            className="intake-text intake-id-first"
            type="text"
            value={answers.firstName}
            readOnly={surveyFlow.fixingGender}
            placeholder="First name"
            autoComplete="off"
            onChange={(e) => surveyFlow.setA({ firstName: e.target.value })}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && surveyFlow.canAdvance) surveyFlow.doNext();
            }}
          />
        </label>
        <label className="intake-idf">
          <span>Last name</span>
          <input
            className="intake-text intake-id-last"
            type="text"
            value={answers.lastName}
            readOnly={surveyFlow.fixingGender}
            placeholder="Last name"
            autoComplete="off"
            onChange={(e) => surveyFlow.setA({ lastName: e.target.value })}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && surveyFlow.canAdvance) surveyFlow.doNext();
            }}
          />
        </label>
      </div>
      <div className="intake-gender-q">Are you male or female?</div>
      <div className="intake-genders">
        {GENDERS.map((o) => (
          <button type="button"
            key={o.value}
            className="intake-gtile"
            aria-pressed={answers.gender === o.value}
            onClick={() => surveyFlow.setA({ gender: o.value })}
          >
            <span className="intake-glabel">{o.label}</span>
          </button>
        ))}
      </div>
    </>
  );
}
